type SmsConfigurationDtoAttributes = {
    phoneNumbers: string[]
    accountId: string
    enabledFeatures: string[]
}

export type SmsConfigurationDto = {
    id: string
    type: string
    attributes: SmsConfigurationDtoAttributes
}

export default class SmsConfiguration {
    private dto: SmsConfigurationDto

    constructor(dto: SmsConfigurationDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return this.getId() != "" && this.dto.type == "sms-configuration"
    }

    getId(): string {
        return this.dto.id
    }

    getEnabledFeatures(): string[] {
        return this.dto.attributes.enabledFeatures
    }


}


// WEBPACK FOOTER //
// ./src/state/sms/SmsConfiguration.ts